<script setup lang="ts">
import {
  DialogRoot,
  type DialogRootEmits,
  type DialogRootProps,
  useForwardPropsEmits,
} from 'radix-vue'
import { onMounted, onUnmounted } from 'vue'

const props = defineProps<DialogRootProps>()
const emits = defineEmits<DialogRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)

// Prevent keyboard events from propagating when dialog is open
function handleKeydown(event: KeyboardEvent) {
  if (props.open && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
    event.stopPropagation()
  }
}

onMounted(() => {
  window.addEventListener('keydown', handleKeydown, true) // Use capture phase
})

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeydown, true)
})
</script>

<template>
  <DialogRoot v-bind="forwarded">
    <slot />
  </DialogRoot>
</template>
